import Axios from "../redux/setupAxios";
import { microserviceNames } from "../app/utils/constants";
import { Urls } from "../app/utils/constants";

const proxyName = microserviceNames.notifications; //proxy/public/notification

export async function getNotificationsByStakeholderId(id, unread, page = 0) {
    return (await Axios.get(`${proxyName}/${Urls.Notification}/${id}?unread=${unread}&page=${page}`)).data;
}

export async function changeNotificationStatus(id) {
    return (await Axios.put(`${proxyName}/${Urls.Notification}/${id}`)).data;
}